/**
 * ScanSection — paper-card scanning (mockup #scan): flow chips, benefits,
 * «جرّب مسح بطاقة» → /scan, and the static scanner illustration.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Camera01Icon, ContactBookIcon, ScanTextIcon, Tick02Icon } from '@hugeicons/core-free-icons';
import Icon from '../../components/v2/Icon.jsx';
import { useStr } from './useStr.js';

/** A long English name may wrap in the narrow cell: keep «Al-Zahrani» whole (word joiner after each hyphen). */
const noBreakAfterHyphen = (s) => s.replace(/-/g, '-\u2060');

const L = ({ children, className = '' }) => <span className={`ltr${className ? ` ${className}` : ''}`}>{children}</span>;

export default function ScanSection() {
  const { t, ar, arrow } = useStr();
  const sep = <span className="sep" aria-hidden="true"><Icon icon={arrow} /></span>;
  return (
    <section className="sx">
      <div className="wrap">
        <div className="pg scan" id="scan">
          <div className="tx">
            <div className="eb"><Icon icon={ScanTextIcon} />{t('scanEb')}</div>
            <h2>
              {ar
                ? <>امسح أي بطاقة عمل ورقية واحفظها في جوالك في <L className="num">3.7</L> ثانية فقط.</>
                : 'Scan any paper business card and save it to your phone in 3.7 seconds.'}
            </h2>
            <p>{t('scanP')}</p>
            <div className="sflow">
              <span className="sfs"><span className="n ltr">01</span>{t('sf1')}</span>
              {sep}
              <span className="sfs on"><span className="n ltr">02</span>{t('sf2')}</span>
              {sep}
              <span className="sfs"><span className="n ltr">03</span>{t('sf3')}<span className="xs-hide">{t('sf3x')}</span></span>
            </div>
            <ul className="ben">
              {['ben1', 'ben2', 'ben3'].map((k) => <li key={k}><Icon icon={Tick02Icon} />{t(k)}</li>)}
            </ul>
            <Link className="btn lg" to="/scan"><Icon icon={Camera01Icon} />{t('scanTry')}</Link>
          </div>
          <div className="scanner" aria-hidden="true">
            <div className="vf">
              <div className="vtop"><span className="rec"><i />{t('camera')}</span><span className="tm ltr">3.7s</span></div>
              <i className="cn k1" /><i className="cn k2" /><i className="cn k3" /><i className="cn k4" />
              <div className="paper">
                <b>{t('paperName')}</b>
                <span>{t('paperRole')}</span>
                <div className="ln" style={{ width: '72%' }} />
                <div className="ln" style={{ width: '56%', background: '#555' }} />
                <div className="ln" style={{ width: '64%', background: '#888' }} />
                <div className="sq" />
              </div>
              <div className="line" />
            </div>
            <div className="ext">
              <div className="exh">
                <span className="d"><Icon icon={Tick02Icon} /></span>
                <div><b>{t('extTitle')}</b><span>{t('extSub')}</span></div>
              </div>
              <div className="exg">
                <div className="nm"><small>{t('exName')}</small><span>{noBreakAfterHyphen(t('paperName'))}</span></div>
                <div><small>{t('exCompany')}</small><span className="ltr vr">CardPass</span></div>
                <div><small>{t('exPhone')}</small><span className="ltr num vr">+966 5X XXX XXXX</span></div>
                <div><small>{t('exEmail')}</small><span className="ltr vr">hello@cardpass.sa</span></div>
              </div>
              <span className="btn full"><Icon icon={ContactBookIcon} />{t('exSave')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
